export default __webpack_public_path__ + "static/media/47_Datel_cerny_www.mezistromy.cz_thumb-min.8a88f9ed.jpg";